import { useQuerySessionById } from '../query/useQuerySessionById';
import { areAllTranscriptsEmpty } from './are-all-transcripts-empty';
import { computeIsTranscriptDeleted } from './is-transcript-deleted';
import { useLiveTranscriptSubscription } from './use-live-transcript-subscription';

/**
 * Reactive "is this session's transcript deleted?" check for UI that disables
 * transcript-dependent controls. Subscribes to the session + live transcript
 * (so a re-record clears the blocked state) and reuses `areAllTranscriptsEmpty`
 * so the UI and the belt agree. Keyed off the marker, not the flag — see
 * `isTranscriptDeletedInCache`.
 */
export const useIsTranscriptDeleted = (sessionId: string): boolean => {
  const { data: markers } = useQuerySessionById({
    sessionId,
    select: (session) => ({
      transcriptDeletedAt: session?.transcript_deleted_at ?? null,
      recordingStatus: session?.recording_status,
    }),
  });

  // Subscribe so later cache writes re-render.
  useLiveTranscriptSubscription(sessionId);

  if (!sessionId) return false;

  return computeIsTranscriptDeleted({
    transcriptDeletedAt: markers?.transcriptDeletedAt,
    recordingStatus: markers?.recordingStatus,
    hasTranscriptContent: !areAllTranscriptsEmpty(sessionId),
  });
};
